import React, { useCallback, useContext, useState } from "react";
import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import { AuthContext } from "./useAuth";
import { PaymentHistoryNotice, runPaymentHistoryFlow } from "./paymentHistory";

export const usePaymentHistoryHandler = () => {
  const { openPaymentHistory } = useContext(AuthContext);
  const [notice, setNotice] = useState<PaymentHistoryNotice | null>(null);

  const handlePaymentHistory = useCallback(
    () => runPaymentHistoryFlow(openPaymentHistory, setNotice),
    [openPaymentHistory],
  );

  const dismiss = useCallback(() => setNotice(null), []);

  const handleSnackbarClose = useCallback(
    (_event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
      if (notice?.kind === "error" && reason === "clickaway") return;
      dismiss();
    },
    [notice, dismiss],
  );

  const isError = notice?.kind === "error";
  const paymentHistorySnackbar = (
    <Snackbar
      open={notice !== null}
      autoHideDuration={isError ? null : 6000}
      onClose={handleSnackbarClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity={isError ? "error" : "success"}
        onClose={dismiss}
        sx={{ width: "100%" }}
      >
        {notice?.message}
      </Alert>
    </Snackbar>
  );

  return { handlePaymentHistory, paymentHistorySnackbar };
};
